export default "__VITE_ASSET__nU31$yls__"